import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import Section1 from "./sections/Section1";
import api from "../../api/axios";
import "./css/Landing.css";

export default function Landing() {
  const { i18n } = useTranslation();
  const [landingIsAuth, setLandingIsAuth] = useState(null);
  const isSkLocale = String(i18n.language || "").toLowerCase().startsWith("sk");
  const isCsLocale = String(i18n.language || "").toLowerCase().startsWith("cs");
  const isRuLocale = String(i18n.language || "").toLowerCase().startsWith("ru");
  const siteOrigin = window.location.hostname === "ru.vaultgrid.net"
    ? "https://ru.vaultgrid.net"
    : "https://vaultgrid.net";
  const pageLang = isRuLocale ? "ru" : isSkLocale ? "sk" : isCsLocale ? "cs" : "en";
  const seoTitle = isRuLocale
    ? "VaultGrid (Волгрид) — мероприятия и общение"
    : isCsLocale
      ? "VaultGrid – události a sociální platforma"
    : isSkLocale
      ? "VaultGrid - podujatia a socialna platforma"
      : "VaultGrid - events and social platform";
  const seoDescription = isRuLocale
    ? "VaultGrid (Волгрид) помогает находить мероприятия, знакомиться с людьми и создавать события в своём городе."
    : isCsLocale
      ? "Objevujte události, seznamujte se s lidmi a žijte aktivní společenský život s VaultGrid."
    : isSkLocale
      ? "Objavujte podujatia, stretavajte ludi a budujte aktivny socialny zivot s VaultGrid."
      : "Discover events, meet people, and build an active social life with VaultGrid.";

  useEffect(() => {
    let cancelled = false;
    api.get("/accounts/auth_status/", {
      meta: {
        authOptional: true,
        suppressUnauthorizedRedirect: true,
      },
    })
      .then(({ data }) => {
        if (!cancelled) {
          setLandingIsAuth(Boolean(data?.isAuthenticated));
        }
      })
      .catch(() => {
        if (!cancelled) {
          setLandingIsAuth(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <Helmet>
        <html lang={pageLang} />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="robots" content="index,follow,noimageindex" />
        <link rel="canonical" href={`${siteOrigin}/`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={`${siteOrigin}/`} />
        <meta property="og:image" content="https://vaultgrid.net/android-chrome-512x512.png" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="hidden md:block">
        <Section1 isMobile={false} isAuth={landingIsAuth} onNavigate={() => {}} />
      </div>
      <div className="md:hidden">
        <Section1 isMobile isAuth={landingIsAuth} onNavigate={() => {}} />
      </div>
    </>
  );
}
